



























































import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"
import ErrorMessage from "@/components/ErrorMessage.vue"
import {Validation} from "@/lib/Validation"

@Component({components: {ErrorMessage}})
export default class SignUp extends Vue {

  private email: string = ""
  private given_name: string = ""
  private family_name: string = ""
  private password: string = ""

  private errors: object = {}

  private loading: boolean = false

  async onSubmit() {

    this.errors = {}
    if (!this.validate()) return

    this.loading = true
    try {
      await vxm.auth.signup({
        email      : this.email,
        given_name : this.given_name,
        family_name: this.family_name,
        password   : this.password
      })
        .catch(e => {
          throw e
        })
      await this.$router.push({name: "SignUpVerifyCode"})
    } catch (e) {
      console.error(e)
      switch (e.code) {
        case "InvalidParameterException":
          alert("入力項目に不備があります")
          break
        case "UsernameExistsException":
          this.errors = {email: ["Already exists."]}
          break
        case "InvalidPasswordException":
          this.errors = {password: ["Invalid password format."]}
          break
        default:
          alert("不明なエラー")
          console.error(e)
      }
    } finally {
      this.loading = false
    }
  }

  validate(): boolean {

    const validation = new Validation({
      email      : {
        required   : true,
        mailaddress: true
      },
      given_name : {
        required : true,
        maxLength: 18
      },
      family_name: {
        required : true,
        maxLength: 18
      },
      password   : {
        required: true
        // password: true
      }
    })

    const check: boolean = validation.validate({
      email      : this.email,
      given_name : this.given_name,
      family_name: this.family_name,
      password   : this.password
    })

    if (!check) this.errors = validation.getErrors()

    return check
  }
}
